/**
 * Specifies whether the UnderlyingFxRate(1045) should be multiplied or divided.
 * tag: 1046
 * @readonly
 * @enum {string} (char)
 */
export enum UnderlyingFXRateCalc {
  /** Divide */
  Divide = 'D',
  /** Multiply */
  Multiply = 'M',
}
